import { useQueryState } from 'next-usequerystate';

export const useContactSidebar = () => {
    const [isContactSidebarOpen, setIsContactSidebarOpen] = useQueryState('contactSidebar', {
        defaultValue: '',
        shallow: true,
    });

    const openContactSidebar = () => setIsContactSidebarOpen('true');

    const closeContactSidebar = () => setIsContactSidebarOpen(null);

    return { isContactSidebarOpen, openContactSidebar, closeContactSidebar } as const;
};
